import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        equipmentLists: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        equipmentListMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getEquipmentListsRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveEquipmentLists", null);
            } else {
                dispatch("receivingEquipmentLists"); // สถานะ กำลังบันทึก

                const formData = new FormData();
                formData.append('item_type_master_code', payload.item_type_master_code);
                formData.append('start_date', payload.start_date); //วันที่จะยืม
                formData.append('end_date', payload.end_date);// วันที่จะคืน

                axios.get('/equipment_lists', {params: payload})
                    .then(function (res) {
                        dispatch("receiveEquipmentLists", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveEquipmentLists", null);
                    });

            }
        },
        loadEquipmentListRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveEquipmentList", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingEquipmentList");
                axios.get('/equipment_lists/' + id).then(res => {
                    dispatch("receiveEquipmentList", res.data);
                })
            }
        },
        updateEquipmentListRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingEquipmentList");
            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('item_id', payload.item_id);
            formData.append('item_type_master_code', payload.item_type_master_code);
            formData.append('item_name', payload.item_name);
            formData.append('item_h_image', payload.news_h_image_th);
            formData.append('active', payload.active);
            axios.post('/update_equipment_lists', formData).then(res => {
                dispatch("updateEquipmentList", res.data);
            })

        },
        createEquipmentListRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingEquipmentList");

            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('item_id', payload.item_id);
            formData.append('item_type_master_code', payload.item_type_master_code);
            formData.append('item_name', payload.item_name);
            formData.append('item_h_image', payload.news_h_image_th);
            formData.append('active', payload.active);
            axios.post('/equipment_lists', formData).then(res => {
                dispatch("receiveEquipmentList", res.data);

            })


        },
        deleteEquipmentListRequest({dispatch}, payload) {

            dispatch("afterDeleteEquipmentList", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingEquipmentList", payload);

            axios.post('/delete_equipment_lists', payload).then(res => {
                dispatch("deleteEquipmentList", {item_id: payload.item_id, res: res});
            })


        },
        receiveEquipmentLists({commit}, payload) {
            commit("RECEIVED_DATAS", payload)
        },
        receivingEquipmentLists({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        receiveEquipmentList({commit}, payload) {
            commit("RECEIVED_DATA", payload)
        },
        receivingEquipmentList({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        updateEquipmentList({commit}, payload) {
            commit("UPDATED_DATA", payload)
        },
        updatingEquipmentList({commit}) {
            commit("UPDATING_DATA") //  call matutions --> state.isUpdating = true;
        },
        deleteEquipmentList({commit}, payload) {
            commit("DELETED_DATA", payload)
        },
        deletingEquipmentList({commit}, payload) {
            commit("DELETING_DATA", payload)
        },
        afterDeleteEquipmentList({commit}, payload) {
            commit("AFFTER_DELETED_DATA", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_DATAS(state, payload) {
            state.equipmentLists = payload;
            state.isReceiving = false;

        },
        RECEIVING_DATAS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_DATA(state, payload) {


            if (payload.item_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let equipmentListMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    equipmentListMessage: (state.equipmentListMessage == equipmentListMessage ? equipmentListMessage + ' ' : equipmentListMessage),

                });
            } else {
                let equipmentListMessage = 'บันทึกสำเร็จ! รายการ ' + payload.item_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    equipmentLists: [...state.equipmentLists, payload],
                    isReceiving: false,
                    errorMessage: false,
                    equipmentListMessage: (state.equipmentListMessage == equipmentListMessage ? equipmentListMessage + ' ' : equipmentListMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_DATA(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_DATA(state, payload) {
            let index = state.equipmentLists.findIndex(p => p.item_id === payload.item_id);
            let equipmentListMessage = 'บันทึกสำเร็จ! รายการ ' + payload.item_id + ' ถูกแก้ไขแล้ว';

            state = Object.assign(state, {
                equipmentLists: state.equipmentLists.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                equipmentListMessage: (state.equipmentListMessage == equipmentListMessage ? equipmentListMessage + ' ' : equipmentListMessage),
            })
        },
        UPDATING_DATA(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_DATA(state, payload) {
            console.log(payload)


            if (payload.res.data.item_id == undefined || payload.res.data.message == 'Relation') {
                let equipmentListMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.item_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    equipmentListMessage: (state.equipmentListMessage == equipmentListMessage ? equipmentListMessage + ' ' : equipmentListMessage),

                });
            } else {
                let indexToDelete = state.equipmentLists.findIndex(p => p.item_id === payload.res.data.item_id);
                let equipmentLists = [...state.equipmentLists];
                equipmentLists.splice(indexToDelete, 1);
                let equipmentListMessage = 'บันทึกสำเร็จ! รายการ ' + payload.res.data.item_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    equipmentLists: [...equipmentLists],
                    isDeleting: false,
                    idToDelete: null,
                    equipmentListMessage: (state.equipmentListMessage == equipmentListMessage ? equipmentListMessage + ' ' : equipmentListMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_DATA(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.item_id;
        },
        AFFTER_DELETED_DATA(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
